import { Button } from '@alf/uikit';

import styles from './index.module.css';

const defaultActionTypes = {
  inProgress: 'color2',
  available: 'color5',
  new: 'color1',
  completed: 'color3',
  expired: 'color3',
  proposed: 'color2',
  offer: 'color2',
  wagering: 'color2',
  spinning: 'color2'
};

const ActionButton = ({
  status,
  onClick,
  title = '',
  className = '',
  isActivation = false,
  isRequestProcessing = false,
  fullWidth,
  actionType,
  intent = 'primary'
}) => (
  <Button
    fullWidth={fullWidth}
    intent={intent}
    actionType={actionType || defaultActionTypes[status]}
    size="l"
    className={`${styles.button} ${className}`}
    onClick={onClick}
    processing={isActivation}
    disabled={isActivation || isRequestProcessing}
    data-testid="bonus-action-button"
  >
    {title}
  </Button>
);

export default ActionButton;
